const Brands = require('../../../brands.json');

// Get Tracker ID from response headers
const getTrackerId = (response: any): string => {
  try {
    // Check if response and response.headers are defined
    if (response && response.headers && Brands && Brands.tracker_id_header) {
      return response.headers[Brands.tracker_id_header] === undefined ? '' : response.headers[Brands.tracker_id_header];
    }
    return ''; // Return empty string if anything is missing
  } catch (error) {
    console.error(error);
    return '';
  }
};

// Get URL from response config
const getUrl = (response: any): string => {
  try {
    // Check if response.config is defined
    if (response && response.config && response.config.url) {
      return response.config.url;
    }
    return ''; // Return empty string if URL is undefined or missing
  } catch (error) {
    console.error(error);
    return '';
  }
};

// Get error code from error or response
const getErrorCode = (errorCode: any, response: any): string => {
  try {
    if (errorCode && errorCode.code) {
      return errorCode.code;
    } else if (response && response.status) {
      return response.status;
    }
    return ''; // Return empty string if no error code or status found
  } catch (error) {
    console.error(error);
    return '';
  }
};

// Request Helper export functions
export const RequestHelper = {
  getTrackerId: (response: any): string => {
    return getTrackerId(response);
  },
  getUrl: (response: any): string => {
    return getUrl(response);
  },
  getErrorCode: (error: any, response: any): string => {
    return getErrorCode(error, response);
  }
};
